export abstract class Criteria {
  public abstract displayValues(values: string[]): string;
}